import React, {useContext, useEffect, useState} from 'react';
import {observer} from "mobx-react-lite";
import {Context} from "../../../index";
import {delAssType, delLanguage, fetchAssTypes, fetchLanguages} from "../../../http/bookAPI";
import Modal from "react-bootstrap/Modal";
import {Dropdown, Form, Spinner} from "react-bootstrap";

const DeleteAssignType = observer(({ show, handleClose }) => {
    const {book} = useContext(Context)
    const [atypeValue, setATypeValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchAssTypes().then(data => book.setAssTypes(data))
    }, []);

    const killAssType = async () => {
        setLoading(true);
        setError('');
        try {
            // Отправляем DELETE запрос с параметром id в URL
            await delAssType(book?.selectedAssType?.id); // Просто передаём ID языка
            const updatedAssType = await fetchAssTypes(); // Обновляем список жанров
            book.setAssTypes(updatedAssType);
            book.setSelectedAssType({}); // Сбрасываем выбранный language
            setATypeValue(''); // Очищаем поле ввода
            handleClose(); // Закрываем модальное окно
        } catch (e) {
            const errorMessage = e.response?.data?.message || 'An error occurred while adding the language.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={() => {
            setError('');
            handleClose();
        }} centered>

            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Delete Assignment Type:</h1>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                    ></button>
                </div>

                <div className="card">
                    <div className="card-body">

                        <div className="d-flex justify-content-center mt-3">

                            <Dropdown className="dropdown-center">
                                <Dropdown.Toggle variant="success" className="shadow">
                                    {book?.selectedAssType?.ass_type || "Select Assignment Type to Modify"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {book.asstypes.map((at) => (
                                        <Dropdown.Item
                                            onClick={() => {book.setSelectedAssType(at);
                                                setATypeValue(at.ass_type);
                                            }}
                                            key={at.id}
                                        >
                                            {at.ass_type}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                <div className="modal-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Form>
                        <Form.Control
                            value={atypeValue}
                            onChange={(e) => setATypeValue(e.target.value)}

                            disabled={true} // Отключаем, если ничего не выбрано
                        />
                    </Form>
                </div>
                <div className="modal-footer">

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={killAssType}
                        disabled={!atypeValue.trim() || loading}
                    >
                        {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Delete from DB'}
                    </button>

                </div>
            </div>
        </Modal>
    );
});



export default DeleteAssignType;